import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { alpha } from '@mui/material/styles';

const CustomerCase = () => {
	return (

		<Container id="testimonials" component="section">
			<Paper
				elevation={0}
				sx={{
					width: '100%',
					borderRadius: 2,
					overflow: 'hidden',
					background: `linear-gradient(135deg, 
						#F8F4E3 0%,
						#F8F4E3 50%,
						#FFE6E6 75%,
						#F5E6FF 85%,
						#EBE0FF 100%
					)`,
					position: 'relative',
					p: { xs: 4, sm: 6 },
				}}
			>
				<Typography
					variant="subtitle1"
					sx={{
						color: 'primary.main',
						fontWeight: 500,
						mb: 2,
					}}
				>
					ASIAKASKOKEMUS
				</Typography>

				<Typography
					variant="h2"
					sx={{
						fontSize: {
							xs: '1.75rem',
							sm: '2.5rem',
							md: '3rem',
						},
						fontWeight: 500,
						lineHeight: 1.2,
						mb: 3,
						maxWidth: '800px',
					}}
				>

					"Kaikki meni todella hyvin, ja siis ihan äärettömän hyvin."

				</Typography>

				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
						gap: { xs: 3, md: 4 },
					}}
				>
					<Box>
						<Typography
							variant="body1"
							sx={{
								fontSize: {
									xs: '1rem',
									sm: '1.2rem',
									md: '1.3rem',
								},
							}}
						>
							Yrityksen arki on täynnä haasteita, joihin tarvitaan
							oikeat ihmiset oikeaan aikaan. Yksi asiakkaistamme
							kohtasi tilanteen, jossa CRM-järjestelmän ja
							mainospanostusdatan yhdistäminen oli välttämätöntä.
							Projektiin oli varattu{' '}
							<strong>
								100 tuntia työtä ja 4 000 € budjetti
							</strong>
							, mutta ratkaisun löytäminen perinteisin keinoin
							olisi vienyt viikkoja.
						</Typography>

						<Box
							sx={{
								width: '100%',
								height: '1px',
								backgroundColor: alpha('#000', 0.1),
								my: 4,
							}}
						/>

						<Typography
							variant="body1"
							sx={{
								mb: 3,
								fontSize: { xs: '1rem', sm: '1.1rem' },
								fontWeight: 500,
							}}
						>
							<Box component="span" sx={{ fontWeight: 700 }}>
								Kun oikea ihminen löytyy hetkessä, jää enemmän
								aikaa siihen, mikä on tärkeää.
							</Box>{' '}

							Haluatko sinäkin löytää tulevaisuuden huipputalentin
							helposti ja nopeasti? Meiltä saat avun minuuteissa.
						</Typography>

						<Link
							href="https://ace93.typeform.com/to/xcwxrM4n?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx#user_id=xxxxx"

							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: 1,
								color: 'primary.main',
								textDecoration: 'none',
								fontWeight: 500,

							}}
						>
							Aloita nyt <ArrowForwardIcon />

						</Link>
					</Box>

					<Box>
						<Typography
							variant="body1"
							sx={{
								mb: 3,
								fontSize: { xs: '1rem', sm: '1.1rem' },
							}}
						>
							Asiakas päätti kokeilla platformiamme ja yllättyi,

							kuinka helppoa ja nopeaa oikean talentin löytäminen
							voi olla.

						</Typography>

						<Box
							sx={{
								backgroundColor: alpha('#7C55E5', 0.1),
								borderRadius: 2,
								p: 3,
							}}
						>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									gap: 3,
								}}
							>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'flex-start',
										gap: 2,
									}}
								>
									<ArrowForwardIcon
										sx={{
											color: 'primary.main',
											transform: 'rotate(45deg)',
										}}
									/>
									<Typography variant="body1">

										6 minuutissa asiakas kirjautui sisään,
										keskusteli tarpeestaan AI-chatin kanssa,
										valitsi talentin ja teki tilauksen.

									</Typography>
								</Box>

								<Box
									sx={{
										display: 'flex',
										alignItems: 'flex-start',
										gap: 2,
									}}
								>
									<ArrowForwardIcon
										sx={{
											color: 'primary.main',
											transform: 'rotate(45deg)',
										}}
									/>
									<Typography variant="body1">
										Vain 27 tunnissa työ oli valmis
										(resursoidun 100h sijaan) – 73 %
										vähemmän työtunteja kuin arvioitu!
									</Typography>
								</Box>

								<Box
									sx={{
										display: 'flex',
										alignItems: 'flex-start',
										gap: 2,
									}}
								>
									<ArrowForwardIcon
										sx={{
											color: 'primary.main',
											transform: 'rotate(45deg)',
										}}
									/>
									<Typography variant="body1">
										Kokonaiskustannus jäi 1 080 euroon, mikä
										tarkoitti 2 920 € säästöä, eli 70 %
										budjetista.
									</Typography>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Paper>
		</Container>
	);
};

export default CustomerCase;
